import React from "react";
import { Link } from "react-router-dom";
import PageMeta from "./PageMeta";
import "../css/policy.scss";

const PolicyLayout = ({ eyebrow = "Customer care", title, intro, sections }) => (
  <main className="policy-page">
    <PageMeta title={title} description={intro} />
    <section className="policy-hero">
      <div className="container policy-hero__inner">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{intro}</p>
      </div>
    </section>
    <div className="container policy-layout">
      <aside className="policy-nav" aria-label="Customer care pages">
        <p>Need help?</p>
        <Link to="/shipping">Shipping</Link>
        <Link to="/returns">Returns</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/cookies">Cookies</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/faqs">FAQs</Link>
        <Link to="/contact">Contact</Link>
      </aside>
      <div className="policy-content">
        {sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.items && (
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  </main>
);

export default PolicyLayout;
